var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31144 6.43513C9.31144 7.91356 8.27901 8.96419 7.00544 8.96419C5.73187 8.96419 4.69944 7.91356 4.69944 6.43513C4.69944 4.95669 5.73187 4.07326 7.00544 4.07326C8.27901 4.07326 9.31144 4.95669 9.31144 6.43513Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0153 14.9309C13.0153 16.4516 11.2363 17.6843 7.14484 17.6843C3.05333 17.6843 1.27441 16.4516 1.27441 14.9309C1.27441 13.4102 3.90269 12.1774 7.14484 12.1774C10.387 12.1774 13.0153 13.4102 13.0153 14.9309Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4829 1.54431L15.3144 3.33455L17.2744 3.57204L15.8284 4.91596L16.2081 6.85297L14.4829 5.89332L12.7576 6.85297L13.1373 4.91596L11.6913 3.57204L13.6513 3.33455L14.4829 1.54431Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionIcon);
export default __webpack_public_path__ + "static/media/permissionIcon.5e833598b4aeba8bb9a280989507c169.svg";
export { ForwardRef as ReactComponent };